const indexItems = [
  { label: '最新电影', icon: 'ri-film-line', count: '12,800+', desc: '院线大片高清上线' },
  { label: '热播电视剧', icon: 'ri-tv-2-line', count: '9,500+', desc: '每日更新追剧必备' },
  { label: '热门综艺', icon: 'ri-emotion-laugh-line', count: '3,200+', desc: '王牌综艺笑点不断' },
  { label: '动漫番剧', icon: 'ri-ghost-smile-line', count: '8,600+', desc: '日漫国漫一网打尽' },
  { label: '动作大片', icon: 'ri-fire-line', count: '5,400+', desc: '肾上腺素飙升体验' },
  { label: '悬疑推理', icon: 'ri-search-eye-line', count: '4,100+', desc: '烧脑神作层层反转' },
  { label: '喜剧搞笑', icon: 'ri-emotion-happy-line', count: '6,300+', desc: '爆笑解压快乐源泉' },
  { label: '纪录片', icon: 'ri-earth-line', count: '2,900+', desc: '高分纪录真实世界' },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium mb-3 whitespace-nowrap">
            <i className="ri-grid-line"></i>全部分类
          </span>
          <h2 className="font-heading text-[28px] md:text-4xl text-foreground-950 mb-3">影视分类索引</h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-lg mx-auto">
            八大影视分类，快速找到你想看的内容，全网资源精准检索
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
          {indexItems.map((item) => (
            <div
              key={item.label}
              className="bg-background-100 rounded-xl p-5 md:p-6 hover:bg-background-200/70 transition-colors group cursor-pointer text-center"
            >
              <div className="w-12 h-12 mx-auto flex items-center justify-center rounded-xl bg-accent-100 text-accent-600 mb-3 group-hover:bg-accent-200 transition-colors">
                <i className={`${item.icon} text-xl`}></i>
              </div>
              <h3 className="font-heading text-sm md:text-base text-foreground-900 mb-1 whitespace-nowrap">{item.label}</h3>
              <span className="block text-lg font-bold text-primary-600 font-heading mb-1">{item.count}</span>
              <span className="text-xs text-foreground-500">{item.desc}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}